<ng-template #headerTemplate>
    <ng-content></ng-content>
</ng-template>